// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MarketsPage_wrapper_2GNTJ"};